/**
 * Garanti BBVA resmi test kartları.
 * Kaynak: https://dev.garantibbva.com.tr/test-kartlari
 * 3D OTP (tüm kartlar): 147852
 */
export const GARANTI_TEST_CARDS: {
  number: string;
  month: string;
  year: string;
  cvc: string;
  label: string;
}[] = [
  { number: '4282209004348015', month: '08', year: '27', cvc: '123', label: 'Simülatör (3D)' },
  { number: '5549600732695519', month: '04', year: '30', cvc: '244', label: 'BONUS (3D)' },
  { number: '4824898262197018', month: '05', year: '31', cvc: '529', label: 'MONEY (3D)' },
  { number: '9792290849783014', month: '08', year: '31', cvc: '865', label: 'TROY (3D)' },
  { number: '377599936020011', month: '09', year: '30', cvc: '380', label: 'SFAMEX / AMEX (3D)' },
  { number: '4329542729807013', month: '08', year: '29', cvc: '908', label: 'Shop&Fly (3D)' },
  { number: '4273149145316011', month: '01', year: '30', cvc: '115', label: 'BONUS (3D)' },
  { number: '5549602763692019', month: '05', year: '30', cvc: '775', label: 'BONUS (3D)' },
  { number: '375623530840012', month: '05', year: '29', cvc: '4101', label: 'AMEX (3D)' },
  { number: '5549602257210013', month: '02', year: '30', cvc: '689', label: 'BONUS (3D)' },
  { number: '375623270949015', month: '02', year: '29', cvc: '4440', label: 'AMEX (3D)' },
  { number: '4329542955012015', month: '02', year: '29', cvc: '863', label: 'SM (3D)' },
  { number: '9792290527103014', month: '02', year: '31', cvc: '058', label: 'TROY (3D)' },
  { number: '9792290529525016', month: '05', year: '31', cvc: '836', label: 'TROY (3D)' },
];

/** Varsayılan Garanti test kartı (AMEX – kullanıcı ekran görüntüsündeki kart ailesi) */
export const GARANTI_DEFAULT_TEST_CARD = GARANTI_TEST_CARDS[8];
